"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = ({ palette }) => styles_1.createStyles({
    logo: {
        fontSize: '1.75em',
        verticalAlign: 'baseline'
    },
    logoEmblem: {
        fontSize: '1.75em',
        verticalAlign: 'baseline'
    },
    default: {
        color: palette.primary.main
    },
    white: {
        color: palette.common.white
    },
    black: {
        color: palette.common.black
    }
});
//# sourceMappingURL=styles.js.map